export default function unsaveSearchItemActionCreator(userDuck, personalization) {
  return _ref => {
    let {
      id,
      version
    } = _ref;
    return async (dispatch, getState) => {
      const saveEvent = await personalization.unsaveSearchItem({
        id,
        version
      });
      if (saveEvent.responseCode === '200') {
        // Update local save search in redux
        dispatch({
          type: userDuck.types.REMOVE_SAVED_SEARCH_ITEM,
          payload: id
        });
        const {
          user
        } = getState();
        const userSearchIds = userDuck.selectors.getSavedSearchIds({
          user
        });
        const searchIds = userSearchIds.filter(bookmarkId => bookmarkId !== id);

        // update local storage only when save was successful
        personalization.updateUserProfileCache({
          searchIds
        });
      } else {
        throw new Error(saveEvent);
      }
      return saveEvent;
    };
  };
}